import { defineStore } from "pinia";

// Health checks this sign-in has closed: check id -> the fingerprint it had,
// Critical banners and the Health panel's warnings kept apart. A changed
// fingerprint brings the check back, so a SAML error that changes after it was
// dismissed shows again. Kept in this tab's storage, so a reload keeps them,
// and reset at sign-out (queries/session.ts).
export const useAdminBannersStore = defineStore("adminBanners", {
  state: () => ({
    criticalDismissed: {} as Record<string, string>,
    warningDismissed: {} as Record<string, string>,
  }),

  persist: true,

  actions: {
    dismissCritical(id: string, fingerprint: string) {
      this.criticalDismissed = { ...this.criticalDismissed, [id]: fingerprint };
    },

    // stillActive drops the checks that have recovered, so a later failure
    // starts clean.
    dismissWarning(id: string, fingerprint: string, stillActive: (id: string) => boolean) {
      const kept = Object.entries(this.warningDismissed).filter(([other]) => stillActive(other));
      this.warningDismissed = { ...Object.fromEntries(kept), [id]: fingerprint };
    },

    undismiss(id: string) {
      const drop = (record: Record<string, string>) =>
        Object.fromEntries(Object.entries(record).filter(([other]) => other !== id));
      this.criticalDismissed = drop(this.criticalDismissed);
      this.warningDismissed = drop(this.warningDismissed);
    },
  },
});
